import React, {Component, ReactNode} from 'react'
import styled from 'styled-components'
import {Paper} from '@mui/material'
import {RowFlexContainer} from '../../../styledComponents/FlexComponents'
import QRCode from 'react-qr-code'
import {Colors} from '../../../styledComponents/Constants'

interface Props {
    confirmationKey: string
    loginUrlWithConfirmationKey: string
}

export default class ConfirmationKeyNoticePrintComponent extends Component<Props> {
    render(): ReactNode {
        return <PagePaper>
            {this.renderFirstPage()}
            {this.renderSecondPage()}
        </PagePaper>
    }

    private renderFirstPage(): ReactNode {
        return <PageDiv>
            <HeaderArea>
                <UnitOwnerHeader>
                    区分所有者 様
                </UnitOwnerHeader>
                <AssocHeader>
                    管理組合
                </AssocHeader>
            </HeaderArea>
            <MainArea>
                <MainAreaTitle>
                    「素敵ネット」総会機能ご利用のお願い
                </MainAreaTitle>
                <div>
                    日頃より管理組合業務に対しご理解とご協力を賜り、厚くお礼申し上げます。<br/>
                    総会の出席通知票・委任状・議決権行使書の提出は、「素敵ネット」総会機能からご利用いただけます。
                    スマートフォンやパソコンから手軽に意思表明いただけますので、是非ご利用をお願いいたします。&emsp;※従来通り紙での提出も可能です
                </div>
                <div>
                    【総会機能ご利用の流れ】<br/>
                    以下の手順でご利用いただけます。<br/>
                    ① 素敵ネットへのユーザー登録 → ② 区分所有者確認 → ③ 総会議案に対する意思表明
                </div>
                <div>
                    ■ご利用手順<br/>
                    ① 素敵ネットへのユーザー登録<br/>
                    &emsp;ユーザー登録がお済みでない場合は素敵ネットより登録手続きをお願いいたします。<br/>
                    &emsp;素敵ネットURL：https://www.suteki.haseko.jp/resident/login
                    <ConfirmationFlowText>
                        ② 区分所有者確認 操作手順
                        <AdditionalInfo>
                            ※上記、素敵ネットへのユーザー登録完了後に実施してください
                        </AdditionalInfo>
                    </ConfirmationFlowText>
                    <ConfirmationFlowForSP>
                        スマートフォンの場合：二次元コードでの認証（推奨）
                        <FlowArea>
                            <StepArea>
                                <StepChip>STEP１</StepChip>
                                <StepContents>
                                    当マンション専用<br/>
                                    二次元コードを<br/>
                                    カメラで読み取り<br/>
                                    アクセスします
                                    <QRCodeWrapper>
                                        <QRCode size={92} value={this.props.loginUrlWithConfirmationKey}/>
                                    </QRCodeWrapper>
                                </StepContents>
                            </StepArea>
                            <ArrowRight/>
                            <StepArea>
                                <StepChip>STEP２</StepChip>
                                <StepContents>
                                    ｢ログイン｣ボタン<br/>
                                    をタップします
                                    <StepImage
                                        src="/resources/images/confirmationKeyNotice/flow1_step2.png"
                                        alt="区分所有者確認の操作手順（ステップ2・スマートフォン）"
                                    />
                                </StepContents>
                            </StepArea>
                            <ArrowRight/>
                            <StepArea>
                                <StepChip>STEP３</StepChip>
                                <StepContents>
                                    登録済みのメールアド<br/>
                                    レス・パスワードを入<br/>
                                    力しログインします
                                    <StepImage
                                        src="/resources/images/confirmationKeyNotice/flow1_step3.png"
                                        alt="区分所有者確認の操作手順（ステップ3・スマートフォン）"
                                    />
                                </StepContents>
                            </StepArea>
                            <ArrowRight/>
                            <StepArea>
                                <StepChip>STEP４</StepChip>
                                <StepContents>
                                    区分所有者の確認画面<br/>
                                    で選択し、｢完了する｣<br/>
                                    をタップします
                                    <StepImage
                                        src="/resources/images/confirmationKeyNotice/flow1_step4.png"
                                        alt="区分所有者確認の操作手順（ステップ4・スマートフォン）"
                                    />
                                </StepContents>
                            </StepArea>
                        </FlowArea>
                    </ConfirmationFlowForSP>
                    <ConfirmationFlowForPC>
                        パソコンの場合：確認用キーでの認証
                        <ConfirmationKeyArea>
                            当マンション専用
                            <ConfirmationKeyText>
                                確認用キー：
                                <ConfirmationKey>
                                    {this.props.confirmationKey}
                                </ConfirmationKey>
                                <AdditionalInfo>
                                    （全て半角英数字、英字は小文字）
                                </AdditionalInfo>
                            </ConfirmationKeyText>
                        </ConfirmationKeyArea>
                        <FlowArea>
                            <StepArea>
                                <StepChip>STEP１</StepChip>
                                <StepContents>
                                    素敵ネットに<br/>
                                    ログインします
                                    <StepImage
                                        src="/resources/images/confirmationKeyNotice/flow2_step1.png"
                                        alt="区分所有者確認の操作手順（ステップ1・パソコン）"
                                    />
                                </StepContents>
                            </StepArea>
                            <ArrowRight/>
                            <StepArea>
                                <StepChip>STEP２</StepChip>
                                <StepContents>
                                    ｢総会｣アイコンを<br/>
                                    クリックします
                                    <StepImage
                                        src="/resources/images/confirmationKeyNotice/flow2_step2.png"
                                        alt="区分所有者確認の操作手順（ステップ2・パソコン）"
                                    />
                                </StepContents>
                            </StepArea>
                            <ArrowRight/>
                            <StepArea>
                                <StepChip>STEP３</StepChip>
                                <StepContents>
                                    ｢確認用キーを入力す<br/>
                                    る｣をクリックします
                                    <StepImage
                                        src="/resources/images/confirmationKeyNotice/flow2_step3.png"
                                        alt="区分所有者確認の操作手順（ステップ3・パソコン）"
                                    />
                                </StepContents>
                            </StepArea>
                            <ArrowRight/>
                            <StepArea>
                                <StepChip>STEP４</StepChip>
                                <StepContents>
                                    区分所有者の確認画面<br/>
                                    で選択し、｢完了する｣<br/>
                                    をタップします
                                    <StepImage
                                        src="/resources/images/confirmationKeyNotice/flow2_step4.png"
                                        alt="区分所有者確認の操作手順（ステップ4・パソコン）"
                                    />
                                </StepContents>
                            </StepArea>
                        </FlowArea>
                    </ConfirmationFlowForPC>
                    <TextForNextPage>
                        （裏面に続く）
                    </TextForNextPage>
                </div>
            </MainArea>
        </PageDiv>
    }

    private renderSecondPage(): ReactNode {
        return <PageDiv>
            <MainArea>
                <div>
                    <VotingPreferenceFlowText>
                        ③ 総会議案に対する意思表明 操作手順
                    </VotingPreferenceFlowText>
                    <VotingPreferenceFlow>
                        <VotingPreferenceFlowArea>
                            <StepArea>
                                <StepChip>STEP１</StepChip>
                                <StepContents>
                                    素敵ネットにログインし、<br/>
                                    総会メニューを開きます
                                    <StepImage
                                        src="/resources/images/confirmationKeyNotice/flow3_step1.png"
                                        alt="総会議案に対する意思表明の操作手順（ステップ1）"
                                    />
                                </StepContents>
                            </StepArea>
                            <ArrowRight/>
                            <StepArea>
                                <StepChip>STEP２</StepChip>
                                <StepContents>
                                    意思表明を行う<br/>
                                    総会を選択します
                                    <StepImage
                                        src="/resources/images/confirmationKeyNotice/flow3_step2.png"
                                        alt="総会議案に対する意思表明の操作手順（ステップ2）"
                                    />
                                </StepContents>
                            </StepArea>
                            <ArrowRight/>
                            <StepArea>
                                <StepChip>STEP３</StepChip>
                                <StepContents>
                                    内容をご確認の上、｢意思<br/>
                                    表明する｣ボタンを選択し<br/>
                                    ます
                                    <StepImage
                                        src="/resources/images/confirmationKeyNotice/flow3_step3.png"
                                        alt="総会議案に対する意思表明の操作手順（ステップ3）"
                                    />
                                </StepContents>
                            </StepArea>
                            <ArrowRight/>
                        </VotingPreferenceFlowArea>
                        <VotingPreferenceFlowArea>
                            <ArrowRight/>
                            <Step4Area>
                                <StepChip>STEP４</StepChip>
                                <StepContents>
                                    総会の参加方法を選択します
                                    <StepImage
                                        src="/resources/images/confirmationKeyNotice/flow3_step4.png"
                                        alt="総会議案に対する意思表明の操作手順（ステップ4）"
                                    />
                                </StepContents>
                            </Step4Area>
                            <ProxyVoteStepArea>
                                <ProxyVoteStepContents>
                                    <Arrow>
                                        <ArrowBody/>
                                        <ArrowHead/>
                                    </Arrow>
                                    <ProxyVoteStep>
                                        （委任の場合）<br/>
                                        委任先を選択します
                                        <StepImage
                                            src="/resources/images/confirmationKeyNotice/flow3_step5.png"
                                            alt="総会議案に対する意思表明の操作手順（ステップ5）"
                                        />
                                    </ProxyVoteStep>
                                </ProxyVoteStepContents>
                                <RowFlexContainer>
                                    <ArrowLongBody/>
                                    <ArrowHead/>
                                </RowFlexContainer>
                            </ProxyVoteStepArea>
                            <VoteStepArea>
                                （議決権行使の場合）<br/>
                                議案毎の賛否を選択します
                                <StepImage
                                    src="/resources/images/confirmationKeyNotice/flow3_step6.png"
                                    alt="総会議案に対する意思表明の操作手順（ステップ6）"
                                />
                            </VoteStepArea>
                        </VotingPreferenceFlowArea>
                    </VotingPreferenceFlow>
                </div>
                <ImportantNotesArea>
                    ■ご注意事項
                    <ImportantNotesComponent>
                        １. 区分所有者確認について
                        <ImportantNotesText>
                            <ImportantNote>
                                <div>（ア）</div>
                                本機能をご利用いただけるのは１住戸につき１アカウントです。<br/>
                                共有名義の場合は、議決権を行使される方を１名お選びいただき、<br/>
                                その方のアカウントで区分所有者確認を行ってください。
                            </ImportantNote>
                            <ImportantNote>
                                <div>（イ）</div>
                                区分所有者確認は、初回のみ必要です。<br/>
                                確認済みのアカウントでは、２回目の総会以降のご利用時に再度の確認は<br/>
                                不要となります。
                            </ImportantNote>
                            <ImportantNote>
                                <div>（ウ）</div>
                                二次元コードや確認用キーは第三者に渡さず厳重に管理してください。<br/>
                                廃棄する際も情報漏えいに十分ご注意ください。
                            </ImportantNote>
                        </ImportantNotesText>
                    </ImportantNotesComponent>
                    <ImportantNotesComponent>
                        ２. 意思表明について
                        <ImportantNotesText>
                            <ImportantNote>
                                <div>（ア）</div>
                                用紙とWebの両方をご提出いただいた場合、<br/>
                                Webから提出された内容を有効として取り扱います。
                            </ImportantNote>
                            <ImportantNote>
                                <div>（イ）</div>
                                Webでご提出いただいた場合のみ、<br/>
                                提出内容をWeb上で変更することが可能です。
                            </ImportantNote>
                            <ImportantNote>
                                <div>（ウ）</div>
                                複数住戸を所有されている場合、<br/>
                                Webからのご提出内容は、所有されているすべての住戸に一括で適用いたします。<br/>
                                住戸ごとに個別の提出を行う必要はございません。<br/>
                                ※同一管理組合の総会に限ります
                            </ImportantNote>
                        </ImportantNotesText>
                    </ImportantNotesComponent>
                </ImportantNotesArea>
            </MainArea>
        </PageDiv>
    }
}

const PagePaper = styled(Paper)`
  width: fit-content;
  margin: 0 auto;

  @media print {
    box-shadow: none;
  }
`

const PageDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 210mm;
  height: 297mm;
  padding: 20mm 25mm 16mm 25mm;
  break-after: page;
  gap: 20px;
`

const HeaderArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  font-size: 15px;
  width: 100%;
`

const UnitOwnerHeader = styled.div`
  text-align: left;
`

const AssocHeader = styled.div`
  text-align: right;
`

const MainArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 14px;
  gap: 14px;
`

const MainAreaTitle = styled.div`
  font-size: 15px;
  text-decoration: underline;
  text-align: center;
`

const ConfirmationFlowText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 4px;
  gap: 28px;
`

const VotingPreferenceFlowText = styled(ConfirmationFlowText)`
  margin-top: 0;
`

const ConfirmationFlowForSP = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #000000;
  height: 268px;
  padding: 12px 10px;
  gap: 10px;
`

const ConfirmationFlowForPC = styled(ConfirmationFlowForSP)`
  border-top: none;
  height: 313px;
  gap: 6px;
`

const VotingPreferenceFlow = styled(ConfirmationFlowForSP)`
  height: 480px;
  gap: 12px;
`

const FlowArea = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 4px;
`

const VotingPreferenceFlowArea = styled(FlowArea)`
  gap: 12px;
`

const StepArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  font-size: 13px;
`

const Step4Area = styled(StepArea)`
  min-width: 170px;
  max-width: 170px;
`

const StepChip = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 20px;
  margin-bottom: 2px;

  background: #E2E5F4;
  border: 2px solid #B2B9E1;
  border-radius: 9999px;

  font-weight: bold;
  font-size: 14px;
`

const StepContents = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

const StepImage = styled.img`
  width: 100%;
  height: auto;
`

const QRCodeWrapper = styled.div`
  display: block;
  margin: 0 auto 6px;
  width: fit-content;
`

const ArrowRight = styled.div`
  width: 0;
  height: 0;
  border-top: 17px solid transparent;
  border-bottom: 17px solid transparent;
  border-left: 12px solid #4F81BD;
`

const ConfirmationKeyArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 4px solid ${Colors.AccentLight};
  padding: 4px 20px;
  gap: 2px;
  margin-bottom: 4px;
`

const ConfirmationKeyText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  gap: 4px;
`

const ConfirmationKey = styled.div`
  background-color: ${Colors.AccentLight};
  padding: 2px 4px;
`

const AdditionalInfo = styled.div`
  font-size: 12px;
`

const TextForNextPage = styled.div`
  text-align: right;
`

const ProxyVoteStepArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 12px 0;
`

const VoteStepArea = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  font-size: 13px;
  padding-top: 12px;
  gap: 6px;
`

const ProxyVoteStepContents = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  font-size: 13px;
  gap: 12px;
`

const ProxyVoteStep = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 6px;
`

const Arrow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
`

const ArrowBody = styled.div`
  width: 10px;
  height: 15px;
  background-color: #4F81BD;
`

const ArrowLongBody = styled(ArrowBody)`
  width: 182px;
`

const ArrowHead = styled.div`
  width: 0;
  height: 0;
  border-top: 16px solid transparent;
  border-bottom: 16px solid transparent;
  border-left: 15px solid #4F81BD;
  margin-left: -1px;
`

const ImportantNotesArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 14px;
  gap: 4px;
`

const ImportantNotesComponent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 6px;
`

const ImportantNotesText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 10px;
`

const ImportantNote = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 3px;
`
